@if (isShownAlert) {
  <div
    [class.normal]="alertData().status === 'normal'"
    [class.primary]="alertData().status === 'primary'"
    [class.warning]="alertData().status === 'warning'"
    [class.success]="alertData().status === 'success'"
    [class.error]="alertData().status === 'error'"
    [class]="'alert alert-border mt-lg ' + alertClass()">
    <div class="flex justify-between">
      <div class="info flex" [class.items-center]="!hasContent()">
        @if (hasIcon()) {
          @if (alertData().icon) {
            <div class="icon">
              <img
                [src]="
                  alertData().icon ||
                  'assets/icons/heart/' + alertData().status + '.svg'
                "
                alt="icon" />
            </div>
          } @else if (iconTemplate()) {
            <ng-container [ngTemplateOutlet]="iconTemplate()" />
          } @else {
            @switch (alertData().status) {
              @case ('error') {
                <lib-danger-icon iconClass="size-6 text-destructive-500" />
              }

              @case ('success') {
                <lib-tick-icon iconClass="size-6 text-success-500" />
              }

              @case ('primary') {
                <lib-info-icon iconClass="size-6 text-primary-500" />
              }

              @case ('warning') {
                <lib-hold-icon iconClass="size-6 text-warning-500" />
              }
            }
          }
        }

        <div>
          <p
            [class.text-warning-800]="alertData().status === 'warning'"
            class="text-sm font-medium">
            {{ alertData().title }}
          </p>

          @if (alertData().description) {
            <p class="desc text-sm">
              {{ alertData().description }}
            </p>
          }

          @if (hasContent()) {
            <div class="content">
              <ng-content />
            </div>
          }
        </div>
      </div>

      @if (hasCloseIcon()) {
        <button
          type="button"
          class="ms-sm bg-transparent"
          (click)="closeAlert()">
          <lib-close-icon
            [iconClass]="
              'size-6 ' +
              (alertData().status === 'error'
                ? 'text-destructive-500'
                : alertData().status === 'success'
                  ? 'text-success-500'
                  : alertData().status === 'warning'
                    ? 'text-warning-500'
                    : alertData().status === 'primary'
                      ? 'text-primary-500'
                      : 'text-neutral-900')
            " />
        </button>
      }
    </div>
  </div>
}
